/* eslint-disable max-len */
import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import moment from 'moment';
import cn from 'classnames';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { numberWithCommas } from 'helper';
import * as action from '../actions';
import * as c from '../constant';

function ViewModal({
  updateList,
  setFormData,
  handleEdit,
  getTaxCreditTransactionsList,
  isLoading,
  taxCreditTransactionsList,
  id,
}) {
  const OnSetFormData = () => {
    setFormData({
      name: updateList.name || '',
      admin_module_id: updateList.admin_module_id || '',
    });
  };

  useEffect(() => {
    getTaxCreditTransactionsList(id, { 'sort[id]': 'asc' });
    if (!_.isEmpty(updateList)) {
      OnSetFormData();
    }
  }, []);

  return (
    <Modal.Body>
      <div className="">
        <div className="card-content-listing pr-2">
          {isLoading ? (
            <div
              className="loading d-flex text-center justify-content-center align-items-center"
              style={{ height: '500px' }}
            >
              <div className="spinner text-center ">
                <span className="fas fa-5x fa-spin fa-spinner" />
              </div>
            </div>
          ) : (
            <div>
              <table className="table table-striped table-sm">
                <thead className="table-header">
                  <tr className="bg-primary-light">
                    <td className="h3 pl-3" width="500">
                      PIN/EOR Number
                    </td>
                    <td className="h3" width="500">
                      Date
                    </td>
                    <td className="h3" width="500">
                      Actions
                    </td>
                    <td className="h3" width="500">
                      Amount
                    </td>
                    <td className="h3" width="500">
                      Balance
                    </td>
                    <td width="200" />
                  </tr>
                </thead>
                <tbody className="table-details text-dark">
                  {taxCreditTransactionsList?.length !== 0 ? (
                    taxCreditTransactionsList.map((item, i) => {
                      return (
                        <tr key={item.id}>
                          <td className="pl-3 justify-center">
                            {['TRANSACT'].indexOf(
                              _.get(item, 'attributes.type')
                            ) > -1
                              ? _.get(
                                  item,
                                  'attributes.land_transaction_e_or_no'
                                )
                              : _.get(
                                  item,
                                  'attributes.land_application_pin'
                                ) || '---'}
                          </td>
                          <td>
                            {`${moment(
                              _.get(item, 'attributes.created_at')
                            ).format('MM-DD-YYYY HH:mm')}:00` || '---'}
                          </td>
                          <td>{_.get(item, 'attributes.type') || '---'}</td>
                          <td
                            className={cn(
                              ['REDUCE', 'TRANSFER', 'TRANSACT'].indexOf(
                                _.get(item, 'attributes.type')
                              ) > -1 && 'text-danger'
                            )}
                          >
                            <span className="font-weight-bold">
                              {`${
                                ['REDUCE', 'TRANSFER', 'TRANSACT'].indexOf(
                                  _.get(item, 'attributes.type')
                                ) > -1
                                  ? '-'
                                  : ''
                              } PHP`}
                              &nbsp;
                            </span>
                            {numberWithCommas(
                              _.get(item, 'attributes.amount')
                            ) || '---'}
                          </td>
                          <td>
                            <span className="font-weight-bold">PHP&nbsp;</span>
                            {numberWithCommas(
                              _.get(item, 'attributes.balance')
                            ) || '---'}
                          </td>
                          {taxCreditTransactionsList.length === i + 1 ? (
                            <td>
                              <button
                                type="button"
                                onClick={handleEdit(updateList)}
                                className="btn btn-blank cms-text-primary"
                              >
                                <i className="fas fa-plus" />
                                &nbsp;Add
                              </button>
                            </td>
                          ) : (
                            <td />
                          )}
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={4} className="text-center">
                        No Results Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </Modal.Body>
  );
}

ViewModal.propTypes = {
  getTaxCreditTransactionsList: PropTypes.instanceOf(Function).isRequired,
  taxCreditTransactionsList: PropTypes.instanceOf(Array).isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_TAX_CREDIT) > -1,
  taxCreditTransactionsList:
    _.get(api, `${c.GET_TAX_CREDIT_TRANSACTIONS}.list`) || [],
  isLoading:
    _.get(api, 'loading', []).indexOf(c.GET_TAX_CREDIT_TRANSACTIONS) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(ViewModal);
